module.exports = __webpack_public_path__ + "assets/img/ic-intro-shopping.6b8379f8.png";